export const privacyData = {
  en: [
    {
      title: "Who We Are",
      content:
        "This website is operated by Umi Sushi, a restaurant. If you have any questions about this Privacy Policy, you may contact us using the information provided at the end of this page."
    },
    {
      title: "Information We Collect",
      content: [
        "We do not collect personal information such as names, email addresses, phone numbers, or payment details directly through this website.",
        "However, when you visit our website, limited technical information may be processed automatically in order to operate the site and understand how it is used.",
        "This information is processed in an aggregated and non-identifying manner.",
        "This may include:"
      ],
      list: [
        "Pages visited",
        "Approximate geographic location (country or region)",
        "Device type, operating system, and browser",
        "General usage patterns (such as visit counts)"
      ],
    },
    {
      title: "Analytics",
      content: [
        "We use Vercel Web Analytics to measure website traffic and performance. Vercel Analytics:",
      ],
      list: [
        "Does not use cookies",
        "Does not store personal identifiers",
        "Does not track users across websites",
        "Does not store full IP addresses"
      ],
      footer: "The data collected is used solely to improve the functionality and content of our website."
    },
    {
      title: "Maps and Third-Party Services",
      content: [
        "Our website embeds Google Maps to display the locations of our restaurant.",
        "When Google Maps is loaded, Google may process personal data, such as your IP address and device information, and may use cookies or similar technologies as part of providing the map service. This processing occurs directly between your browser and Google and is governred by Google's own privacy policy.",
        "We do not receive personal data from Google Maps and do not use this information for advertising, profiling, or tracking purposes.",
        "Google Maps is only loaded after user interaction."
      ]
    },
    {
      title: "Legal Basis for Processing (EU/EEA Visitors)",
      content: "For visitors from the European Union and European Economic Area",
      list: [
        "Anonymous analytics data is processed based on our legitimate interest in understanding how our website is used and improving our services. This processing does not override your fundamental rights and freedoms.",
        "Data processed by third-party services such as Google Maps is handled according to those providers' own legal bases and privacy policies."
      ]
    },
    {
      title: "Cookies",
      content:[
        "We do not use tracking cookies for advertising or profiling purposes.",
        "However, third-party services embedded on this website, such as Google Maps, may use cookies or similar technologies as part of their operation. We do not control these technologies."
      ]
    },
    {
      title: "Data Sharing",
      content: [
        "We do not sell, rent, or trade your information. Anonymous analytics data is processed by our website hosting and analytics provider (Vercel) solely for the purposes described in this policy.",
        "Third-party services such as Google Maps process data independently under their own privacy policies."
      ]
    },
    {
      title: "Your Rights",
      content: [
        "Depending on your location, you may have rights under applicable data protection laws, including the right to request access to or deletion of personal data.",
        "Because we do not collect or store personally identifiable information through this website, there is typically no personal data for us to identify or delete.",
        "For data processed by third parties (such as Google), requests should be directed to the relevant provider."
      ]
    },
    {
      title: "Third-Party Links",
      content:
        "Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of those websites."
    },
    {
      title: "Changes to This Policy",
      content:
        "We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. Any updates will be posted on this page."
    },
    {
      title: "Contact Us",
      content:
        "If you have questions about this Privacy Policy or our data practices, please contact us at:\n\nUmi Sushi\nTel: +351 289 153 829"
    }
  ],

  pt: [
    {
      "title": "Quem Somos",
      "content": "Este website é operado pelo Umi Sushi, um restaurante. Se tiver alguma dúvida sobre esta Política de Privacidade, pode contactar-nos utilizando a informação fornecida no final desta página."
    },
    {
      "title": "Informações que Recolhemos",
      "content": [
        "Não recolhemos informações pessoais como nomes, endereços de email, números de telefone ou dados de pagamento diretamente através deste website.",
        "No entanto, ao visitar o nosso website, informações técnicas limitadas podem ser processadas automaticamente para operar o site e compreender como é utilizado.",
        "Estas informações são processadas de forma agregada e não identificável.",
        "Isto pode incluir:"
      ],
      "list": [
        "Páginas visitadas",
        "Localização geográfica aproximada (país ou região)",
        "Tipo de dispositivo, sistema operativo e navegador",
        "Padrões gerais de utilização (como contagem de visitas)"
      ]
    },
    {
      "title": "Análise",
      "content": [
        "Usamos Vercel Web Analytics para medir o tráfego e desempenho do website. Vercel Analytics:"
      ],
      "list": [
        "Não utiliza cookies",
        "Não armazena identificadores pessoais",
        "Não rastreia utilizadores noutros websites",
        "Não armazena endereços IP completos"
      ],
      "footer": "Os dados recolhidos são usados apenas para melhorar a funcionalidade e conteúdo do nosso website."
    },
    {
      "title": "Mapas e Serviços de Terceiros",
      "content": [
        "O nosso website incorpora o Google Maps para mostrar a localização do restaurante.",
        "Quando o Google Maps é carregado, o Google pode processar dados pessoais, como o seu endereço IP e informação do dispositivo, e pode usar cookies ou tecnologias similares como parte do serviço de mapas. Este processamento ocorre diretamente entre o seu navegador e o Google e é regido pela política de privacidade do Google.",
        "Não recebemos dados pessoais do Google Maps e não utilizamos esta informação para publicidade, perfilamento ou rastreio.",
        "O Google Maps só é carregado após a interação do utilizador."
      ]
    },
    {
      "title": "Base Legal para o Processamento (Visitantes da UE/EEE)",
      "content": "Para visitantes da União Europeia e do Espaço Económico Europeu",
      "list": [
        "Dados anónimos de análise são processados com base no nosso interesse legítimo em compreender como o website é usado e em melhorar os nossos serviços. Este processamento não sobrepõe os seus direitos e liberdades fundamentais.",
        "Dados processados por serviços de terceiros, como o Google Maps, são tratados de acordo com as bases legais e políticas de privacidade desses fornecedores."
      ]
    },
    {
      "title": "Cookies",
      "content": [
        "Não utilizamos cookies de rastreio para publicidade ou perfilamento.",
        "No entanto, serviços de terceiros incorporados neste website, como o Google Maps, podem usar cookies ou tecnologias similares como parte da sua operação. Não controlamos estas tecnologias."
      ]
    },
    {
      "title": "Partilha de Dados",
      "content": [
        "Não vendemos, alugamos nem trocamos a sua informação. Dados de análise anónimos são processados pelo nosso fornecedor de alojamento e análise (Vercel) apenas para os fins descritos nesta política.",
        "Serviços de terceiros, como o Google Maps, processam dados de forma independente, de acordo com as suas próprias políticas de privacidade."
      ]
    },
    {
      "title": "Os Seus Direitos",
      "content": [
        "Dependendo da sua localização, poderá ter direitos segundo as leis de proteção de dados aplicáveis, incluindo o direito de solicitar acesso ou eliminação de dados pessoais.",
        "Como não recolhemos nem armazenamos informações pessoalmente identificáveis através deste website, normalmente não existem dados pessoais que possamos identificar ou eliminar.",
        "Para dados processados por terceiros (como o Google), os pedidos devem ser dirigidos ao respetivo fornecedor."
      ]
    },
    {
      "title": "Links de Terceiros",
      "content": "O nosso website pode conter links para websites de terceiros. Não somos responsáveis pelas práticas de privacidade nem pelo conteúdo desses websites."
    },
    {
      "title": "Alterações a Esta Política",
      "content": "Podemos atualizar esta Política de Privacidade de tempos a tempos para refletir mudanças nas nossas práticas ou requisitos legais. Quaisquer atualizações serão publicadas nesta página."
    },
    {
      "title": "Contacte-nos",
      "content": "Se tiver dúvidas sobre esta Política de Privacidade ou sobre as nossas práticas de dados, contacte-nos em:\n\nUmi Sushi\nTel: +351 289 153 829"
    }
  ],

  es: [
    {
      "title": "Quiénes Somos",
      "content": "Este sitio web es operado por Umi Sushi, un restaurante. Si tiene alguna pregunta sobre esta Política de Privacidad, puede contactarnos utilizando la información proporcionada al final de esta página."
    },
    {
      "title": "Información que Recogemos",
      "content": [
        "No recopilamos información personal como nombres, direcciones de correo electrónico, números de teléfono o datos de pago directamente a través de este sitio web.",
        "Sin embargo, al visitar nuestro sitio web, se puede procesar automáticamente información técnica limitada para el funcionamiento del sitio y para comprender cómo se utiliza.",
        "Esta información se procesa de forma agregada y no identificable.",
        "Esto puede incluir:"
      ],
      "list": [
        "Páginas visitadas",
        "Ubicación geográfica aproximada (país o región)",
        "Tipo de dispositivo, sistema operativo y navegador",
        "Patrones generales de uso (como número de visitas)"
      ]
    },
    {
      "title": "Analítica",
      "content": [
        "Usamos Vercel Web Analytics para medir el tráfico y el rendimiento del sitio web. Vercel Analytics:"
      ],
      "list": [
        "No utiliza cookies",
        "No almacena identificadores personales",
        "No realiza seguimiento de usuarios en otros sitios web",
        "No almacena direcciones IP completas"
      ],
      "footer": "Los datos recopilados se usan únicamente para mejorar la funcionalidad y el contenido de nuestro sitio web."
    },
    {
      "title": "Mapas y Servicios de Terceros",
      "content": [
        "Nuestro sitio web incorpora Google Maps para mostrar la ubicación de nuestro restaurante.",
        "Cuando se carga Google Maps, Google puede procesar datos personales, como su dirección IP y la información de su dispositivo, y puede usar cookies o tecnologías similares como parte del servicio de mapas. Este procesamiento ocurre directamente entre su navegador y Google y está regido por la política de privacidad de Google.",
        "No recibimos datos personales de Google Maps ni usamos esta información para publicidad, creación de perfiles o seguimiento.",
        "Google Maps solo se carga tras la interacción del usuario."
      ]
    },
    {
      "title": "Base Legal para el Procesamiento (Visitantes de la UE/EEE)",
      "content": "Para visitantes de la Unión Europea y del Área Económica Europea",
      "list": [
        "Los datos de analítica anónimos se procesan basándose en nuestro interés legítimo de comprender cómo se utiliza nuestro sitio web y mejorar nuestros servicios. Este procesamiento no anula sus derechos y libertades fundamentales.",
        "Los datos procesados por servicios de terceros como Google Maps se manejan según las bases legales y políticas de privacidad de dichos proveedores."
      ]
    },
    {
      "title": "Cookies",
      "content": [
        "No usamos cookies de seguimiento con fines publicitarios o de creación de perfiles.",
        "Sin embargo, los servicios de terceros incorporados en este sitio web, como Google Maps, pueden usar cookies o tecnologías similares como parte de su funcionamiento. No controlamos estas tecnologías."
      ]
    },
    {
      "title": "Compartir Datos",
      "content": [
        "No vendemos, alquilamos ni intercambiamos su información. Los datos de analítica anónimos son procesados por nuestro proveedor de alojamiento y analítica web (Vercel) únicamente para los fines descritos en esta política.",
        "Los servicios de terceros, como Google Maps, procesan los datos de manera independiente según sus propias políticas de privacidad."
      ]
    },
    {
      "title": "Sus Derechos",
      "content": [
        "Dependiendo de su ubicación, puede tener derechos según las leyes de protección de datos aplicables, incluyendo el derecho a solicitar acceso o eliminación de datos personales.",
        "Dado que no recopilamos ni almacenamos información identificable personalmente a través de este sitio web, normalmente no hay datos personales que podamos identificar o eliminar.",
        "Para los datos procesados por terceros (como Google), las solicitudes deben dirigirse al proveedor correspondiente."
      ]
    },
    {
      "title": "Enlaces de Terceros",
      "content": "Nuestro sitio web puede contener enlaces a sitios web de terceros. No somos responsables de las prácticas de privacidad ni del contenido de esos sitios web."
    },
    {
      "title": "Cambios en Esta Política",
      "content": "Podemos actualizar esta Política de Privacidad de vez en cuando para reflejar cambios en nuestras prácticas o requisitos legales. Cualquier actualización se publicará en esta página."
    },
    {
      "title": "Contáctenos",
      "content": "Si tiene preguntas sobre esta Política de Privacidad o nuestras prácticas de datos, contáctenos en:\n\nUmi Sushi\nTel: +351 289 153 829"
    }
  ],

  fr: [
    {
      "title": "Qui Nous Sommes",
      "content": "Ce site web est exploité par Umi Sushi, un restaurant. Si vous avez des questions concernant cette Politique de Confidentialité, vous pouvez nous contacter en utilisant les informations fournies à la fin de cette page."
    },
    {
      "title": "Informations que Nous Collectons",
      "content": [
        "Nous ne collectons pas d’informations personnelles telles que noms, adresses e-mail, numéros de téléphone ou informations de paiement directement via ce site web.",
        "Cependant, lors de votre visite sur notre site, des informations techniques limitées peuvent être traitées automatiquement afin d’assurer le fonctionnement du site et de comprendre son utilisation.",
        "Ces informations sont traitées de manière agrégée et non identifiable.",
        "Cela peut inclure :"
      ],
      "list": [
        "Pages consultées",
        "Localisation géographique approximative (pays ou région)",
        "Type d’appareil, système d’exploitation et navigateur",
        "Modèles généraux d’utilisation (comme le nombre de visites)"
      ]
    },
    {
      "title": "Analytique",
      "content": [
        "Nous utilisons Vercel Web Analytics pour mesurer le trafic et les performances du site web. Vercel Analytics :"
      ],
      "list": [
        "N’utilise pas de cookies",
        "Ne stocke pas d’identifiants personnels",
        "Ne suit pas les utilisateurs sur d’autres sites web",
        "Ne stocke pas les adresses IP complètes"
      ],
      "footer": "Les données collectées sont utilisées uniquement pour améliorer la fonctionnalité et le contenu de notre site web."
    },
    {
      "title": "Cartes et Services Tiers",
      "content": [
        "Notre site intègre Google Maps pour afficher l’emplacement de notre restaurant.",
        "Lorsque Google Maps est chargé, Google peut traiter des données personnelles telles que votre adresse IP et les informations de votre appareil, et peut utiliser des cookies ou technologies similaires dans le cadre de son service de cartographie. Ce traitement se fait directement entre votre navigateur et Google et est régi par la politique de confidentialité de Google.",
        "Nous ne recevons pas de données personnelles de Google Maps et n’utilisons pas ces informations à des fins publicitaires, de profilage ou de suivi.",
        "Google Maps n’est chargé qu’après l’interaction de l’utilisateur."

      ]
    },
    {
      "title": "Base Légale du Traitement (Visiteurs UE/EEE)",
      "content": "Pour les visiteurs de l’Union Européenne et de l’Espace Économique Européen",
      "list": [
        "Les données analytiques anonymes sont traitées sur la base de notre intérêt légitime à comprendre l’utilisation de notre site et à améliorer nos services. Ce traitement ne porte pas atteinte à vos droits et libertés fondamentaux.",
        "Les données traitées par des services tiers tels que Google Maps sont gérées conformément aux bases légales et politiques de confidentialité de ces fournisseurs."
      ]
    },
    {
      "title": "Cookies",
      "content": [
        "Nous n’utilisons pas de cookies de suivi à des fins publicitaires ou de profilage.",
        "Cependant, les services tiers intégrés à ce site web, tels que Google Maps, peuvent utiliser des cookies ou technologies similaires dans le cadre de leur fonctionnement. Nous ne contrôlons pas ces technologies."
      ]
    },
    {
      "title": "Partage de Données",
      "content": [
        "Nous ne vendons, louons ni échangeons vos informations. Les données analytiques anonymes sont traitées par notre fournisseur d’hébergement et d’analytique (Vercel) uniquement pour les finalités décrites dans cette politique.",
        "Les services tiers tels que Google Maps traitent les données de manière indépendante selon leurs propres politiques de confidentialité."
      ]
    },
    {
      "title": "Vos Droits",
      "content": [
        "Selon votre localisation, vous pouvez bénéficier de droits en vertu des lois applicables sur la protection des données, y compris le droit de demander l’accès ou la suppression de données personnelles.",
        "Comme nous ne collectons ni ne stockons d’informations personnellement identifiables via ce site, il n’y a généralement pas de données personnelles à identifier ou à supprimer.",
        "Pour les données traitées par des tiers (comme Google), les demandes doivent être adressées au fournisseur concerné."
      ]
    },
    {
      "title": "Liens Tiers",
      "content": "Notre site peut contenir des liens vers des sites tiers. Nous ne sommes pas responsables des pratiques de confidentialité ni du contenu de ces sites."
    },
    {
      "title": "Modifications de Cette Politique",
      "content": "Nous pouvons mettre à jour cette Politique de Confidentialité de temps à autre pour refléter les changements de nos pratiques ou des exigences légales. Toute mise à jour sera publiée sur cette page."
    },
    {
      "title": "Nous Contacter",
      "content": "Si vous avez des questions concernant cette Politique de Confidentialité ou nos pratiques en matière de données, veuillez nous contacter à :\n\nUmi Sushi\nTel : +351 289 153 829"
    }
  ]

};
